import { Fragment, useState, useEffect } from 'react'
import { withVersionHeaders } from '../../utils/changelogGroups'
import { changelogAPI } from '../../services/api'

import { logger } from '@/utils/logger'

interface ChangelogEntry {
  id: number
  git_hash: string
  title: string
  category: string
  scope: string | null
  version?: string | null
  created_at: string
}

const categoryTag: Record<string, { className: string; label: string; style?: React.CSSProperties }> = {
  feature: { className: 'wc-tag-accent', label: 'Feature' },
  improvement: { className: 'wc-tag-neutral', label: 'Verbesserung' },
  bugfix: { className: 'wc-tag-outline', label: 'Fehlerbehebung' },
  security: {
    className: 'wc-tag-outline',
    label: 'Sicherheit',
    style: { borderColor: '#fca5a5', color: '#fca5a5' },
  },
}

export default function ChangelogCard() {
  const [entries, setEntries] = useState<ChangelogEntry[]>([])

  useEffect(() => {
    changelogAPI
      .getAll()
      .then((res) => setEntries(res.data))
      .catch((err) => logger.error('Error loading changelog:', err))
  }, [])

  if (entries.length === 0) return null

  return (
    <div className="wc-card wc-elev-sm" style={{ gap: 14 }}>
      <h3 className="wc-card-title" style={{ margin: 0 }}>Letzte Änderungen &amp; Updates</h3>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {withVersionHeaders(entries).map(({ entry, header }) => {
          const tag = categoryTag[entry.category] || { className: 'wc-tag-neutral', label: entry.category }
          return (
            <Fragment key={entry.id}>
            {header && (
              <div className="wc-muted" style={{ fontSize: 12, fontWeight: 600, paddingTop: 8 }}>v{header}</div>
            )}
            <div className="wc-row" style={{ gap: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                <span className={`wc-tag ${tag.className}`} style={{ ...tag.style, flexShrink: 0 }}>
                  {tag.label}
                </span>
                <span style={{ fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {entry.title}
                </span>
              </div>
              <span className="wc-muted" style={{ fontSize: 12, flexShrink: 0 }}>
                {new Date(entry.created_at).toLocaleDateString('de-DE', {
                  day: '2-digit',
                  month: '2-digit',
                  year: '2-digit',
                })}
              </span>
            </div>
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}
